(function() { window.GUID_ea1b314c_68f6_48f3_9f8d_8566d2564b2c = { getGuid: function() { return "ea1b314c-68f6-48f3-9f8d-8566d2564b2c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventsLinkerActionType;
        (function (EventsLinkerActionType) {
            EventsLinkerActionType[EventsLinkerActionType["Link"] = 1] = "Link";
            EventsLinkerActionType[EventsLinkerActionType["Unlink"] = 2] = "Unlink";
            EventsLinkerActionType[EventsLinkerActionType["Follow"] = 3] = "Follow";
            EventsLinkerActionType[EventsLinkerActionType["Unfollow"] = 4] = "Unfollow";
        })(EventsLinkerActionType = Enumeration.EventsLinkerActionType || (Enumeration.EventsLinkerActionType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventsLinkerActionType.pre.js.map
